var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMinus = function SvgMinus(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66907 16.0001C6.66907 15.2637 7.266 14.6667 8.00238 14.6667H23.9998C24.7361 14.6667 25.3329 15.2637 25.3329 16.0001C25.3329 16.7364 24.736 17.3334 23.9996 17.3334H8.00238C7.266 17.3334 6.66907 16.7364 6.66907 16.0001Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMinus);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNjY5MDcgMTYuMDAwMUM2LjY2OTA3IDE1LjI2MzcgNy4yNjYgMTQuNjY2NyA4LjAwMjM4IDE0LjY2NjdIMjMuOTk5OEMyNC43MzYxIDE0LjY2NjcgMjUuMzMyOSAxNS4yNjM3IDI1LjMzMjkgMTYuMDAwMUMyNS4zMzI5IDE2LjczNjQgMjQuNzM2IDE3LjMzMzQgMjMuOTk5NiAxNy4zMzM0SDguMDAyMzhDNy4yNjYgMTcuMzMzNCA2LjY2OTA3IDE2LjczNjQgNi42NjkwNyAxNi4wMDAxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";